import styled from '@emotion/styled';
import { ClassAttributes, createElement } from 'react';

type Props = ClassAttributes<HTMLElement> & {
  size?: number;
  className?: string;
};

const OwnedMediaIcon = ({ size = 24, className }: Props) => (
  <Root
    width={size}
    height={size}
    className={className}
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <title>ownedmedia</title>
    <defs />
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="ownedmedia">
        <rect
          id="Path"
          stroke="#000000"
          strokeWidth="2"
          fill="#FFFFFF"
          fillRule="nonzero"
          x="1"
          y="1"
          width="22"
          height="22"
          rx="3"
        />
        <polygon id="Shape" points="0 0 24 0 24 24 0 24" />
        <path
          d="M20,20 L4,20 L4,17 L20,17 L20,20 Z M20,16 L4,16 L4,13 L20,13 L20,16 Z M20,11 L13,11 L13,8 L20,8 L20,11 Z M20,7 L13,7 L13,4 L20,4 L20,7 Z M11,11 L4,11 L4,4 L11,4 L11,11 Z"
          id="Shape"
          fill="#000000"
          fillRule="nonzero"
        />
      </g>
    </g>
  </Root>
);

const Root = styled('svg')();

export default OwnedMediaIcon;
